import { action, makeAutoObservable } from "mobx";

import { UploadFile } from "../models/classes/upload-file.class";

export class TranscriptionStore {
  private _uploadFiles: UploadFile[] = [];
  private _currentProgressessingFiles: UploadFile[] = [];

  constructor() {
    makeAutoObservable(this, {
      addProgressingFile: action,
      removeProgressingFile: action,
    });
  }

  public get uploadFiles(): UploadFile[] {
    return this._uploadFiles;
  }

  public set uploadFiles(value: UploadFile[]) {
    this._uploadFiles = value;
  }

  public get isAnyFileProgressing(): boolean {
    return this._currentProgressessingFiles.length > 0;
  }

  public addProgressingFile(file: UploadFile): void {
    this._currentProgressessingFiles = [...this._currentProgressessingFiles, file];
  }

  public removeProgressingFile(file: UploadFile): void {
    this._currentProgressessingFiles = this._currentProgressessingFiles.filter(f => f.id !== file.id);
  }

  public containsProgressingFile(file: UploadFile): boolean {
    return this._currentProgressessingFiles.some(f => f.id === file.id);
  }

  public currentProgressingFiles(): UploadFile[] {
    return this._currentProgressessingFiles;
  }
}
